import { Link } from 'react-router-dom';
import { useConsent } from '../context/ConsentContext';
import { useLanguage } from '../context/LanguageContext';
import { tours } from '../data/tours';
import { getLocalizedTour } from '../i18n/localizedTours';
import { getTourPath } from '../utils/tourRoutes';

const partyBoatTour = tours.find((tour) => tour.id === 1);
const cityTour = tours.find((tour) => tour.id === 13);
const keyWestTour = tours.find((tour) => tour.id === 11);
const vanTour = tours.find((tour) => tour.id === 2);
const orlandoTour = tours.find((tour) => tour.id === 6);
const sawgrassTour = tours.find((tour) => tour.id === 12);

export default function Footer() {
  const { language, localizePath, t } = useLanguage();
  const { openPreferences } = useConsent();
  const localizedPartyBoatTour = getLocalizedTour(partyBoatTour, language);
  const localizedCityTour = getLocalizedTour(cityTour, language);
  const localizedKeyWestTour = getLocalizedTour(keyWestTour, language);
  const localizedVanTour = getLocalizedTour(vanTour, language);
  const localizedOrlandoTour = getLocalizedTour(orlandoTour, language);
  const localizedSawgrassTour = getLocalizedTour(sawgrassTour, language);

  return (
    <footer className="site-footer">
      <div className="container footer-top">
        <div className="footer-brand-block">
          <span className="footer-kicker">{t('footer.kicker')}</span>
          <h3>Miami Tours and Travel</h3>
          <p>
            {t('footer.description')}
          </p>
          <div className="footer-pills">
            <span className="footer-pill">{t('footer.pillPickup')}</span>
            <span className="footer-pill">{t('footer.pillOutside')}</span>
            <span className="footer-pill">{t('footer.pillSupport')}</span>
          </div>
        </div>

        <div className="footer-contact-card">
          <p className="footer-contact-label">{t('footer.quickHelp')}</p>
          <a href="tel:+13054910131" className="footer-call-btn">
            {t('footer.callText')}
          </a>
          <span>{t('footer.fastHelp')}</span>
          <a href="https://www.miamitoursandtravel.com" className="footer-site-link">
            miamitoursandtravel.com
          </a>
          <a
            href="https://g.page/r/CXXpjbmPOif2EBM/review"
            target="_blank"
            rel="noreferrer"
            className="footer-site-link"
          >
            {t('footer.reviewGoogle')}
          </a>
          <a
            href="https://www.youtube.com/@Miamitoursandtravel"
            target="_blank"
            rel="noreferrer"
            className="footer-site-link"
          >
            {t('navbar.viewYouTube')}
          </a>
        </div>
      </div>

      <div className="container footer-grid">
        <div className="footer-column">
          <h4>{t('footer.explore')}</h4>
          <div className="footer-links">
            <Link to={localizePath('/tours')}>{t('footer.allTours')}</Link>
            <Link to={localizePath('/things-to-do-in-miami')}>{t('footer.thingsToDoMiami')}</Link>
            <Link to={localizePath('/miami-boat-tours')}>{t('footer.miamiBoatTours')}</Link>
            <Link to={localizePath('/guides')}>{t('footer.guides')}</Link>
            <Link to={getTourPath(partyBoatTour, language)}>{localizedPartyBoatTour.name}</Link>
            <Link to={getTourPath(cityTour, language)}>{localizedCityTour.name}</Link>
            <Link to={getTourPath(keyWestTour, language)}>{localizedKeyWestTour.name}</Link>
          </div>
        </div>

        <div className="footer-column">
          <h4>{t('footer.transportation')}</h4>
          <div className="footer-links">
            <Link to={localizePath('/transportation')}>{t('footer.transportationPage')}</Link>
            <Link to={getTourPath(vanTour, language)}>{localizedVanTour.name}</Link>
            <Link to={getTourPath(orlandoTour, language)}>{localizedOrlandoTour.name}</Link>
            <Link to={getTourPath(sawgrassTour, language)}>{localizedSawgrassTour.name}</Link>
            <span>{t('footer.outsidePickup')}</span>
          </div>
        </div>

        <div className="footer-column">
          <h4>{t('footer.bookingHelp')}</h4>
          <div className="footer-links">
            <span>{t('footer.reserveOnline')}</span>
            <span>{t('footer.secureCheckout')}</span>
            <span>{t('footer.pickupConfirmed')}</span>
            <span>{t('footer.customCoordination')}</span>
            <Link to={localizePath('/luggage-storage')}>{t('footer.luggageStorage')}</Link>
            <button type="button" className="footer-link-button" onClick={openPreferences}>
              {t('footer.cookieSettings')}
            </button>
            <Link to={localizePath('/privacy')}>{t('footer.privacy')}</Link>
            <Link to={localizePath('/accessibility')}>{t('footer.accessibility')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
